import { render, staticRenderFns } from "./AdminListingTab.vue?vue&type=template&id=05552db1&"
import script from "./AdminListingTab.vue?vue&type=script&lang=js&"
export * from "./AdminListingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports